/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(2, 3, 3, 3),
    background: 'transparent !important',
    position: "relative",
    overflow: "auto",
  },
  appBarWrap: {
    display: "flex",
    flexDirection: "row",
    background: 'transparent !important',
  },
  textInputSignIn: {
    maxWidth: '32%',
  },
  textInput: {
  },
  blockSignInCheckBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-4'],
  },
  footerActionsWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  cancelBtn: {

  },
  saveSettingsBtn: {

  },
  userDetailWrap: {
    overflow: "scroll",
    borderRadius: Tokens.spacing['$sp-1']
  },
  userDetailRightWrap: {
    
  },
  dropDownText: {
    '& #dropdown-inputlabel-IDPDropdown': {
      fontSize: Tokens.spacing['$sp-4-5']
    },
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    color: theme.palette.text.primary,
    '& .MuiCircularProgress-colorPrimary': {
      color: theme.palette.text.primary,
    },
    padding: Tokens.spacing['$sp-3']
  },
  subjectIdWrap: {
    width: "100%",
    marginTop: Tokens.spacing['$sp-6'],
  },
  tabHeader: {
    fontSize: Tokens.spacing['$sp-4-5'],
  },
  backIcon: {
    height: Tokens.spacing['$sp-12'],
    width: Tokens.spacing['$sp-12'],
    color: theme.palette.text.primary
  },
  userDetailsTabsWrap: {
    width: theme.spacing(18.75)
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4']
  },
  heading: {
    color: theme.palette.text.secondary
  },
  userNameInputContent: {
    width: `${5 * 8}%`
  },
  userNameInput: {
    marginTop: Tokens.spacing['$sp-8-5'],
    "&.MuiInput-input": {
      marginTop: Tokens.spacing['$sp-8-5']
    }
  },
  contentContainer: {
    marginTop: Tokens.spacing['$sp-6'],
  },
  tabs: {
    borderBottomColor: theme.palette.divider,
    borderBottomStyle: 'solid',
    borderBottomWidth: 'thin'
  },
  tab: {
    borderBottom: 'none !important',
    color: `${theme.palette.text.primary}  !important`,
    "&.Mui-selected span": {
      color: `${theme.palette.primary.main}  !important`,
    },
    "& .Mui-selected span": {
      color: `${theme.palette.primary.main}  !important`,
    }
  },
  tabpanel: {
    padding: 0
  },
  tabSection: {
    paddingLeft: Tokens.spacing['$sp-10']
  },
  tabGeneralSection: {
    padding: 0,
  },
  mfaWrap: {
    paddingLeft: Tokens.spacing['$sp-4'],
    marginRight: Tokens.spacing['$sp-4'],
  },
  gridViewWrap: {
    paddingRight: Tokens.spacing['$sp-2'],
    paddingTop: Tokens.spacing['$sp-3'],
  },
  nativeUserContainer: {
    padding: 0,
    "& header": {
      padding: 0,
      margin: 0
    },
  },
  divider: {
    marginTop: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-6'],
    marginRight: Tokens.spacing['$sp-4']
  },
  toolsBar: {
    display: "flex",
    justifyContent: 'flex-end',
    background: theme.palette.grey[50],
    paddingRight: Tokens.spacing['$sp-2'],
    paddingLeft: Tokens.spacing['$sp-2'],
    paddingBottom: Tokens.spacing['$sp-0-5'],
    paddingTop: Tokens.spacing['$sp-0-5'],
    alignItems: 'center',
    minHeight: Tokens.spacing['$sp-12']
  },
  toolBarButton: {
    marginRight: Tokens.spacing['$sp-3']
  },
  rightToolBarButton: {
    marginRight: Tokens.spacing['$sp-3']
  },
  serverErrorMessage: {
    margin: Tokens.spacing['$sp-4'],
    marginBottom: 0
  },
  nativeUserTabHeaderWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttonWrapper: {
    display: 'inline-flex'
  },
  modalTextBoxPhone: {
    paddingRight: Tokens.spacing['$sp-2-5'],
    marginTop: Tokens.spacing['$sp-3'],
    color: theme.palette.text.primary,
    width: "100%",
    '&.PhoneInput .PhoneInputCountrySelectArrow': {
      marginLeft: Tokens.spacing['$sp-4']
    },
    '&.PhoneInput .PhoneInputInput': {
      marginLeft: Tokens.spacing['$sp-2']
    },
    '&.PhoneInput .PhoneInputInput, &.PhoneInput .PhoneInputCountry': {
      border: 'none',
      outline: 'none',
      paddingBottom: Tokens.spacing['$sp-2'],
      paddingTop: Tokens.spacing['$sp-2'],
      marginBottom: Tokens.spacing['$sp-0-25'],
      borderBottom: `1px solid ${theme.palette.secondary.light}`,
    },
    '&.PhoneInput .PhoneInputInput:hover, &.PhoneInput .PhoneInputCountry:hover': {
      border: 'none',
      outline: 'none',
      marginBottom: Tokens.spacing['$sp-0'],
      borderBottom: `${Tokens.spacing['$sp-0-5']} solid ${theme.palette.secondary.main}`,
    },
    '&.PhoneInput.PhoneInput--focus .PhoneInputInput, &.PhoneInput.PhoneInput--focus .PhoneInputCountry': {
      border: 'none',
      outline: 'none',
      marginBottom: Tokens.spacing['$sp-0'],
      borderBottom: `${Tokens.spacing['$sp-0-5']} solid ${theme.palette.primary.main}`,
    }
  },
  modalTextBoxPhoneError: {
    '&.PhoneInput .PhoneInputInput, &.PhoneInput .PhoneInputCountry ': {
      borderBottom: `1px solid ${theme.palette.error.main}`,
    },
    '&.PhoneInput .PhoneInputInput:hover, &.PhoneInput .PhoneInputCountry:hover': {
      borderBottom: `${Tokens.spacing['$sp-0-5']} solid ${theme.palette.error.main}`,
    },
    '&.PhoneInput.PhoneInput--focus .PhoneInputInput, &.PhoneInput.PhoneInput--focus .PhoneInputCountry': {
      borderBottom: `${Tokens.spacing['$sp-0-5']} solid ${theme.palette.error.main}`,
    },
  },
  mobilePhoneError: {
    marginLeft: Tokens.spacing['$sp-4']
  },
  countrySelectArrow: {
    fontSize: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-2']
  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-4']
  },
  warningInfoWrap: {
    marginBottom: Tokens.spacing['$sp-4'],
  },
  resetPasswordWrap: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconBox: {
    float: 'right',
    marginTop: Tokens.spacing['$sp-5'],
  },
  iconAlignment: {
    cursor: "pointer"
  },
  resetPasswordTextField: {
    width: '60%',
  },
  resetPasswordInput: {
    marginTop: Tokens.spacing['$sp-3'],
    marginBottom: Tokens.spacing['$sp-3'],
  },
  policyTextWrap: {
    padding: Tokens.spacing['$sp-4'],
  },
  policyText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: Tokens.spacing['$sp-2'],
  },
  checkBoxWrap: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-4'],
  },
  loaderStyle: {
    position: 'absolute',
    marginTop: Tokens.spacing['$sp-4'],
    alignSelf: 'right',
    left: '44%'
  },
  resetPasswordButton: {
    marginRight: Tokens.spacing['$sp-2'],
  }
}));
